import React, { useState, useEffect } from 'react';
import Graphs from '../components/Graphs';
import useHandleQuery from "../utils/dropdown_data_loading/useHandleQuery";
import  Shimmer_graph_man from './MAN_info_graphs'
import graphicon from '../assets/images/graph.png';
import { Button, OverlayTrigger, Popover } from 'react-bootstrap';
import { useFilterContext } from './FilterContext';
import { useResetContext } from './ResetContext';
import useInvokeAgent from "../utils/useInvokeAgent";


const YourComponent = ({selected_value,username}) => {
  console.log('test',username)
  const [isLoading, setIsLoading] = useState(false);
  const [loadingProgress, setLoadingProgress] = useState(0);
  const { filterdata, updateFilterData } = useFilterContext();
  const { resetdata } = useResetContext();

  console.log('yoyrkdnkd',selected_value)
  const [isButtonClicked, setIsButtonClicked] = useState(false);
  const handleQuery = useHandleQuery();
  const invokeAgent = useInvokeAgent();

  // Progress simulation effect
  useEffect(() => {
    let interval;
    if (isLoading) {
      setLoadingProgress(4); // Start at 4%
      interval = setInterval(() => {
        setLoadingProgress(prev => {
          if (prev >= 85) return prev; // Cap at 85% until loading completes
          return prev + Math.random() * 2.8 + 0.7; // Increment 0.7-3.5%
        });
      }, 1000); // Every 1 second
    } else {
      setLoadingProgress(0); // Reset when not loading
    }
    
    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLoading]);

  const handlegraphclick = ({ selectedValues }) => {
    setIsButtonClicked(true);
    setIsLoading(true);
  
    // Ensure resetdata is included in payload (following useInvokeAgent.js pattern)
    const payloadWithReset = {
      selectedValues: selectedValues || {},
      resetdata: resetdata || 'Bus', // Default to 'Bus' if resetdata not available
      username: username
    };
  
    updateFilterData(prevState => ({
      ...prevState,
      button_clicked: true,
      username: username,
      selectedValues: selectedValues,
      resetdata: resetdata
    }));
  
    // 🔁 Run handleQuery independently with resetdata included
    handleQuery({ selectedValues: selectedValues || {}, username, resetdata })
      .catch(error => console.error("Error in handleQuery:", error))
      .finally(() => {
        setLoadingProgress(100); // Complete progress
        setTimeout(() => {
          setIsLoading(false); // Hide loading after brief 100% display
        }, 1000); // Show 100% for 1 second
      });
  
    // 🔁 Run invokeAgent independently with resetdata included (same pattern as useInvokeAgent.js)
    invokeAgent({ selectedValues: selectedValues || {}, resetdata })
      .catch(error => console.error("Error in invokeAgent:", error));
  };
  
  const popover = (
    <Popover id="popover-basic">
      <Popover.Body>
        
      Load statistics based on filter selection
      </Popover.Body>
    </Popover>
  );

  return (
    <div className='graph_div'>
          <OverlayTrigger trigger="hover" placement="right" overlay={popover}>

        <button class="graph-button" onClick={() => handlegraphclick({ selectedValues: selected_value })}>
        <img src={graphicon} alt="button image" className='graph-icon'/>
          </button>
          </OverlayTrigger>
          {isLoading ? <Shimmer_graph_man loadingProgress={loadingProgress} /> : isButtonClicked && <Graphs />}
    </div>
  );
};

export default YourComponent;